import { ChapterHeading } from "../ChapterHeading";
import { Reveal } from "../motion/Reveal";

const PAINS = [
  "Your employee keeps missing deadlines.",
  "They're not meeting expectations.",
  "They keep asking for salary increases.",
  "They're creating friction in the team.",
  "You need them to take more ownership.",
  "You have to communicate a difficult employment decision.",
];

export function Pain() {
  return (
    <section id="pain" className="py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <ChapterHeading
          index="01"
          eyebrow="The problem"
          title={
            <>
              You've had this <em className="font-normal">conversation</em> before.
            </>
          }
        />
        <div className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-xl border border-line bg-line sm:grid-cols-2 lg:grid-cols-3">
          {PAINS.map((pain, i) => (
            <Reveal key={pain} delay={i * 0.06} className="h-full">
              <div
                data-testid={`pain-card-${i + 1}`}
                className="group flex h-full flex-col justify-between gap-10 bg-paper p-7 transition-colors duration-300 hover:bg-white"
              >
                <span className="font-mono text-xs tracking-[0.2em] text-faint transition-colors duration-300 group-hover:text-brand">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <p className="text-lg leading-snug text-ink">{pain}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.15}>
          <p className="mt-10 max-w-xl text-base leading-relaxed text-smoke sm:text-lg">
            You know the conversation needs to happen. The hard part is finding
            the words.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
